// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delivery {
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0;
  visibility: hidden;
  /* transform: scale(0.5); */
  transform: scale(0);
  position: fixed;
  z-index: 1002;
  overflow-y: scroll;
  scrollbar-width: none;
  background: var(--clr-gray300);
  /* animation: 0.5s fadeIn; */
  pointer-events: none;
  transition: 0.25s;
  padding: 1.5em;
  border-radius: 1em;
}

.delivery.no-popup {
  position: static;
  transform: scale(1);
  opacity: 1;
  box-shadow: none;
  visibility: visible;
  pointer-events: all;
}

.delivery.show {
  transform: scale(1);
  opacity: 1;
  visibility: visible;
  pointer-events: all;
}
.delivery__container {
  padding: 1.5em;
}

.delivery::-webkit-scrollbar {
  display: none;
}

.delivery__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.delivery__HeaderText h4 {
  font-weight: bold;
  font-size: 1.25rem;
  margin-bottom: 0.25rem;
  color: var(--clr-primary);
}

.delivery__HeaderText span {
  display: flex;
  align-items: center;
}

.delivery__HeaderText span svg {
  width: 1rem;
  height: 1rem;
  margin-left: 0.5rem;
}

.delivery__options {
  display: grid;
  margin: 2rem 0;
  gap: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr));
}

.delivery__btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-radius: 1em;
}

.delivery__btn svg {
  margin-left: 0.75rem;
  width: 1.5rem;
}

.delivery__maps {
  width: 100%;
  display: flex;
  align-items: center;
  background: #f7f7fc;
  padding: 0.5em 1em;
  border-radius: 0.75em;
  box-shadow: 0px 12px 16px rgba(0, 0, 0, 0.04);
}

.delivery__maps.text {
  flex-direction: column;
  align-items: unset;
  font-family: "Jost" !important;
  line-height: 1.65;
  padding-top: 1em;
  padding-bottom: 1em;
  font-size: 0.9rem;
  font-weight: bold;
  color: var(--clr-gray600);
}

.delivery__mapsSearch {
  cursor: pointer;
}

.delivery__maps.text ul {
  list-style: disc;
  padding-left: 1.5em;
}

.delivery__maps.text li {
  font-weight: bold;
}

.delivery__maps img {
  width: 1.25rem;
}

.delivery__mapsMenu {
  cursor: pointer;
}

.delivery__mapContainer {
  width: 100%;
  height: 20rem;
  border-radius: 0.75em;
  position: relative;
  overflow: hidden;
  margin-top: 2rem;
}

.delivery__maps input {
  width: 100%;
  padding: 0.75em 0;
  margin: 0 0.75rem;
  border: none;
  background: transparent;
  outline: none;
}

.delivery__errorMap {
  background: var(--clr-error);
  color: var(--clr-error-dark);
  display: block;
  padding: 1em;
  border-radius: 0.75em;
  margin-bottom: 1rem;
}

@media (min-width: 768px) {
  .delivery {
    width: 100%;
    max-width: 30rem;
    height: -moz-fit-content;
    height: fit-content;
    /* height: 80%; */
    margin: auto;
    box-shadow: 0 0.75rem 1rem #0002;
    border-radius: 1em;
    /* border: 0.1rem solid var(--clr-gray800); */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Delivery/Delivery.css"],"names":[],"mappings":"AAAA;EACE,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,8BAA8B;EAC9B,4BAA4B;EAC5B,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,SAAS;EACT,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,wBAAmB;IAAnB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;IAClB,6CAA6C;EAC/C;AACF","sourcesContent":[".delivery {\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  opacity: 0;\n  visibility: hidden;\n  /* transform: scale(0.5); */\n  transform: scale(0);\n  position: fixed;\n  z-index: 1002;\n  overflow-y: scroll;\n  scrollbar-width: none;\n  background: var(--clr-gray300);\n  /* animation: 0.5s fadeIn; */\n  pointer-events: none;\n  transition: 0.25s;\n  padding: 1.5em;\n  border-radius: 1em;\n}\n\n.delivery.no-popup {\n  position: static;\n  transform: scale(1);\n  opacity: 1;\n  box-shadow: none;\n  visibility: visible;\n  pointer-events: all;\n}\n\n.delivery.show {\n  transform: scale(1);\n  opacity: 1;\n  visibility: visible;\n  pointer-events: all;\n}\n.delivery__container {\n  padding: 1.5em;\n}\n\n.delivery::-webkit-scrollbar {\n  display: none;\n}\n\n.delivery__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.delivery__HeaderText h4 {\n  font-weight: bold;\n  font-size: 1.25rem;\n  margin-bottom: 0.25rem;\n  color: var(--clr-primary);\n}\n\n.delivery__HeaderText span {\n  display: flex;\n  align-items: center;\n}\n\n.delivery__HeaderText span svg {\n  width: 1rem;\n  height: 1rem;\n  margin-left: 0.5rem;\n}\n\n.delivery__options {\n  display: grid;\n  margin: 2rem 0;\n  gap: 1rem;\n  grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr));\n}\n\n.delivery__btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  border-radius: 1em;\n}\n\n.delivery__btn svg {\n  margin-left: 0.75rem;\n  width: 1.5rem;\n}\n\n.delivery__maps {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  background: #f7f7fc;\n  padding: 0.5em 1em;\n  border-radius: 0.75em;\n  box-shadow: 0px 12px 16px rgba(0, 0, 0, 0.04);\n}\n\n.delivery__maps.text {\n  flex-direction: column;\n  align-items: unset;\n  font-family: \"Jost\" !important;\n  line-height: 1.65;\n  padding-top: 1em;\n  padding-bottom: 1em;\n  font-size: 0.9rem;\n  font-weight: bold;\n  color: var(--clr-gray600);\n}\n\n.delivery__mapsSearch {\n  cursor: pointer;\n}\n\n.delivery__maps.text ul {\n  list-style: disc;\n  padding-left: 1.5em;\n}\n\n.delivery__maps.text li {\n  font-weight: bold;\n}\n\n.delivery__maps img {\n  width: 1.25rem;\n}\n\n.delivery__mapsMenu {\n  cursor: pointer;\n}\n\n.delivery__mapContainer {\n  width: 100%;\n  height: 20rem;\n  border-radius: 0.75em;\n  position: relative;\n  overflow: hidden;\n  margin-top: 2rem;\n}\n\n.delivery__maps input {\n  width: 100%;\n  padding: 0.75em 0;\n  margin: 0 0.75rem;\n  border: none;\n  background: transparent;\n  outline: none;\n}\n\n.delivery__errorMap {\n  background: var(--clr-error);\n  color: var(--clr-error-dark);\n  display: block;\n  padding: 1em;\n  border-radius: 0.75em;\n  margin-bottom: 1rem;\n}\n\n@media (min-width: 768px) {\n  .delivery {\n    width: 100%;\n    max-width: 30rem;\n    height: fit-content;\n    /* height: 80%; */\n    margin: auto;\n    box-shadow: 0 0.75rem 1rem #0002;\n    border-radius: 1em;\n    /* border: 0.1rem solid var(--clr-gray800); */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
